import req from "@/methods/request";

//文件选择器
export const imageList = function (data) {
    return req({
        url: '/manage/upload/imagePicker',
        ...data,
    })
}

//上传图片
export const uploadFile = function (data) {
    return req({
        url: '/manage/upload/uploadFile',
        ...data,
        mode: 'upload'
    })
}

//阿里oss上传参数
export const ossFile = function (data) {
    return req({
        url: '/manage/upload/ossFile',
        ...data
    })
}

// 可选分组
export const getGroupCate = function (data) {
    return req({
        url: '/manage/group/getGroupCate',
        ...data
    })
}

// 新增文件分组
export const AddGroup = function (data) {
    return req({
        url: '/manage/group/addGroup',
        ...data
    })
}

// 编辑文件分组
export const EditGroup = function (data) {
    return req({
        url: '/manage/group/editGroup',
        ...data
    })
}

// 删除文件分组
export const DelGroup = function (data) {
    return req({
        url: '/manage/group/delGroup',
        ...data
    })
}

// 修改图片分组
export const editFileGroup = function (data) {
    return req({
        url: '/manage/group/editFileGroup',
        ...data
    })
}

// 修改图片名称
export const editFileName = function (data) {
    return req({
        url: '/manage/group/editFileName',
        ...data
    })
}

// 删除文件
export const delFile = function (data) {
    return req({
        url: '/manage/group/delFile',
        ...data
    })
}